import { Text } from "@mantine/core";
import IconLoadingAddress from "icons/shipment/loading-address.svg";
import IconUnloadingAddress from "icons/shipment/unloading-address.svg";
import { useTranslation } from "react-i18next";
import InfoItem from ".";

interface InfoItemAddressProps {
  address?: string | null;
  name?: string | null;
}

export const InfoItemReceiver: React.FC<InfoItemAddressProps> = ({
  address,
  name,
}) => {
  const { t } = useTranslation("tripActivity");

  return (
    <InfoItem
      lh={1}
      visible={Boolean(address)}
      icon={
        <IconUnloadingAddress
          width={24}
          height={24}
          className="text-red-dark"
        />
      }
      label={
        <Text lh={1}>
          {address}
        </Text>
      }
      description={
        <DescriptionWithPrefix prefix={t("receiver")} description={name} />
      }
    />
  );
};

export const InfoItemSender: React.FC<InfoItemAddressProps> = ({
  address,
  name,
}) => {
  const { t } = useTranslation("tripActivity");

  return (
    <InfoItem
      lh={1}
      visible={Boolean(address)}
      icon={
        <IconLoadingAddress width={24} height={24} className="text-green" />
      }
      label={<Text lh={1}>{address}</Text>}
      description={
        <DescriptionWithPrefix prefix={t("sender")} description={name} />
      }
    />
  );
};

const DescriptionWithPrefix = ({
  prefix,
  description,
}: {
  prefix: string;
  description?: string | null;
}) => {
  if (!description) {
    return null;
  }

  return (
    <Text component="span" fz={10} lh={1} className="block truncate">
      {prefix}: {description}
    </Text>
  );
};
